/**
 * DealCurrencyContext — React binding for currency SSOT.
 * App provides one instance per deal state; consumers format via useDealCurrency().
 */
import { createContext, useContext, useMemo } from 'react';
import { createCurrencySsot } from '../utils/currencySsot';

const DealCurrencyContext = createContext(null);

export function DealCurrencyProvider({
  operatingCurrency,
  countryCode,
  fx,
  outputs,
  outputsChf,
  taxLabel,
  children,
}) {
  const value = useMemo(
    () => createCurrencySsot({
      operatingCurrency,
      countryCode,
      fx,
      outputs,
      outputsChf,
      taxLabel,
    }),
    [operatingCurrency, countryCode, fx, outputs, outputsChf, taxLabel],
  );

  return (
    <DealCurrencyContext.Provider value={value}>
      {children}
    </DealCurrencyContext.Provider>
  );
}

export function useDealCurrency() {
  const ctx = useContext(DealCurrencyContext);
  if (!ctx) {
    // Safe fallback for isolated tests / story renders
    return createCurrencySsot({});
  }
  return ctx;
}
